export default __webpack_public_path__ + "static/media/provisions-icon.57a9d9da.svg";